import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  useEditCalendarHolidays,
  useRetrieveCurrentPlanzone,
} from "@planzone/view-models";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { CalendarHolidays } from "@planzone/dto";
import { Form } from "./form";
import { Props } from "./types";
import styles from "./styles.scss";

function CalendarHolidaysEdition({ cancel, calendarHolidays }: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { isRequestPending, editCalendarHolidays } =
    useEditCalendarHolidays(calendarHolidays);
  const [formData, setFormData] = useState<CalendarHolidays>(calendarHolidays);

  return (
    <Modal header={t("calendarHolidays.edition.title")} close={cancel}>
      <form
        className={styles.calendarHolidaysEdition}
        onSubmit={(e) => {
          e.preventDefault();

          !isRequestPending &&
            editCalendarHolidays({
              planzone,
              calendarHolidays,
              nextCalendarHolidays: formData,
            });
        }}
      >
        {!isRequestPending && (
          <div className={styles.main}>
            <Form formData={formData} edit={setFormData} />
          </div>
        )}
        <div className={styles.footer}>
          <Button type="cancel" press={cancel}>
            {t("calendarHolidays.edition.cancel")}
          </Button>
          <Button
            type="submit"
            status={isRequestPending ? "pending" : "none"}
            isDisabled={isRequestPending}
          >
            {t("calendarHolidays.edition.submit")}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export { CalendarHolidaysEdition };
